import React,{useState} from 'react'
import logo1 from './images/logo1.1.png'
import logo2 from './images/logo1.2.png'
import logo3 from './images/logo1.3.png'
import logo4 from './images/logo1.4.png'

export default function Maesrtros() {
    const [AboutActiveTab,setAboutActiveTab] = useState('tab1');

    const handleTabClick = (tab) => {
        setAboutActiveTab(tab);
      };
      const ImageArea = ()=>{
        switch(AboutActiveTab){
            case 'tab1':
                return(
                    <img src={logo1} alt="" />
                );
                case 'tab2':
                return(
                    <img src={logo2} alt="" />
                );
                case 'tab3':
                return(
                    <img src={logo3} alt="" />
                );
                case 'tab4':
                return(
                    <img src={logo4} alt="" />
                );
        }
      }

      const ContaintArea = ()=>{
        switch(AboutActiveTab){
            case 'tab1':
                return(
                    <div className="changable-contant">
                    <div className="second-heading-mestros">
                        <h1>GRAPHIC DESIGN & EDITING</h1>
                    </div>
                    <div className="para-mestros">
                        <p>We provide expert graphic design and editing services tailored to enhance your brand’s visual identity. From static creatives to video content, our work is driven by purposeful creativity and detail. We ensure every visual aligns with your business goals and speaks to your audience. Using innovative tools and techniques, we deliver engaging and professional designs across platforms. Our focus is always on consistency, clarity, and creative communication that elevates your presence.</p>
                    </div>
                    <div className="end-button-mestros">
                        <button><link rel="stylesheet" href="/graphic-design" /> VIEW MORE <link/></button>
                    </div>
                    </div>

                );
                case 'tab2':
                return(
                    <div className="changable-contant">
                    <div className="second-heading-mestros">
                        <h1>SEO</h1>
                    </div>
                    <div className="para-mestros">
                        <p>Our SEO services focus on delivering organic growth through strategic planning and execution. We implement research-backed keyword targeting, mobile-first optimization, and on-page improvements to enhance your site’s visibility. With constant monitoring and updates, we adapt to changing algorithms to maintain performance. Our SEO is driven by results, with a focus on long-term digital presence.</p>
                    </div>
                    <div className="end-button-mestros">
                        <button>VIEW MORE</button>
                    </div>
                    </div>

                );
                case 'tab3':
                return(
                    <div className="changable-contant">
                    <div className="second-heading-mestros">
                        <h1>CONTANT WRITING</h1>
                    </div>
                    <div className="para-mestros">
                        <p>We deliver high-quality content writing that captures your brand’s voice while driving engagement. Whether for websites, blogs, or campaigns, our content is crafted with precision, creativity, and purpose. We research your industry, understand your audience, and develop copy that informs, persuades, and performs. From headlines to call-to-actions, every word is designed to make an impact.</p>
                    </div>
                    <div className="end-button-mestros">
                        <button>VIEW MORE</button>
                    </div>
                    </div>

                );
                case 'tab4':
                return(
                    <div className="changable-contant">
                    <div className="second-heading-mestros">
                        <h1>WEBSITE</h1>
                    </div>
                    <div className="para-mestros">
                        <p>We create responsive, modern websites that reflect your brand and deliver performance. Every website is designed with user experience at its core, combining sleek visuals with intuitive navigation. Our development process ensures fast loading, mobile compatibility, and smooth functionality. We align design with your goals to create a platform that attracts and converts. From layout to backend coding, we build websites that are not just attractive but also result-oriented and future-ready.</p>
                    </div>
                    <div className="end-button-mestros">
                        <button>VIEW MORE</button>
                    </div>
                    </div>

                );
        }

      }
  return (
    <>
    <div className="main-mestros">
      <div className="container main-container-mestros">
        <div className="row row-cols-2 main-row-mastros">
        <div className="col first-main-column-mastros">
            <div className="main-image-mestros">
                {ImageArea()}
            </div>
            </div>
            <div className="col second-main-column-mastros">
                <div className="main-heading-mestrods">
                <h1>WHAT WE ARE MASTERS IN </h1>
                </div>
                <div className="tabs-masrtors">
                    <ul className='ul-mestros'>
                        <li><button onClick={() => handleTabClick('tab1')}autoFocus style={{outline:0 



                        }}>GRAPHICS & EDITING </button></li>
                        <li><button onClick={() => handleTabClick('tab2')}>SEO</button></li>
                        <li><button onClick={() => handleTabClick('tab3')}>CONTENT WRITING</button></li>
                        <li><button onClick={() => handleTabClick('tab4')}>WEBSITE</button></li>



                    </ul>
                </div>
               {ContaintArea()}
            </div>
        </div>
      </div>
      </div>
    </>
  )
}
